import { Button, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Confirmation = ({}) => {
  const navigate = useNavigate(),
    user = useSelector((state) => state.user),
    { t } = useTranslation();

  return (
    <Col noFlex centerAll wid="100%">
      <Row wid="132px" ht="132px" bg={theme.GREEN} hasRadius="132px" centerAll marg="48px 0 0">
        <Icon type="markEmailread" dimensions={52} />
      </Row>

      <Text h1 marg="32px 0 0">
        {t('forgotPassword.recoveryEmailSent')}
      </Text>

      <Text b1 marg="8px 0 0" col={theme.GREY_60} center>
        {t('forgotPassword.checkYourInbox')}
      </Text>

      <Button
        marg="32px 0 0"
        wid="296px"
        app
        onClick={() => navigate(user?._id ? '/settings' : '/login')}
        text={t(user?._id ? 'forgotPassword.backToSettings' : 'forgotPassword.backToLogin')}
      />
    </Col>
  );
};

export default Confirmation;
